export default __webpack_public_path__ + "static/media/Annex-Cafe.96dc3ebd.pdf";